import * as API from "@/api/permission";
import { getIsAccessDisabled } from "@/utils/permissions";

const state = {
  sharingRules: [],
  permissionList: [],
  roleList: [],
  teamList: {},
  userListInRole: [],
  userListInTeam: {},
  teamRelationList: {},
  teamRelationType: [],
  sharingRulesGroup: [],
  showList: true,
  activeTeam: {},
  saveLoading: false, //team sharing rules save loading
  isDisabled: true, //team sharing rules save button disabled
};
const mutations = {
  setSharingRules(state, data) {
    state.sharingRules = data;
  },
  setSaveLoading(state, data) {
    state.saveLoading = data;
  },
  setIsDisabled(state, data) {
    state.isDisabled = data;
  },
  setActiveTeam(state, data) {
    state.activeTeam = data;
  },
  setShowingList(state, data) {
    state.showList = data;
  },
  setPermissionList(state, data) {
    state.permissionList = data;
  },
  setRoleList(state, data) {
    state.roleList = data;
  },
  setTeamList(state, data) {
    state.teamList = data;
  },
  setUserListInRole(state, data) {
    state.userListInRole = data;
  },
  setUserListInTeam(state, data) {
    state.userListInTeam = data;
  },
  setTeamRelationList(state, data) {
    state.teamRelationList = data;
  },
  setTeamRelationType(state, data) {
    state.teamRelationType = data;
  },
  setSharingRulesGroup(state, data) {
    state.sharingRulesGroup = data;
  },
};
const actions = {
  async getSharingRules(context) {
    try {
      const res = await API.getSharingRulesList({
        profile_id: this.state.user.currentId.profile_id,
      });
      context.commit("setSharingRules", res?.data);
    } catch (error) {
      console.log(error);
    }
  },
  async getPermissionList(context) {
    const currentId = this.state.user.currentId.profile_id;
    const params = {
      profile_id: currentId,
    };
    try {
      const res = await API.getPermissionList(params);
      context.commit("setPermissionList", res.data);
      return res.data;
    } catch (err) {
      console.log(err);
      throw err;
    }
  },
  async getRoleList(context, data) {
    if (getIsAccessDisabled(context.rootState?.user?.roles_access_code)) {
      return;
    }
    const currentId = this.state.user.currentId.profile_id;
    const max_team = this.state.user.systemConfig.default_iam_max_team_snippets;
    const max_user = this.state.user.systemConfig.default_iam_max_user_snippets;
    const params = {
      profile_id: currentId,
      max_user_snippets: max_team,
      max_team_snippets: max_user,
      is_full_page_search: true,
      // page: 1,
      // per_page: 25,
      ...data,
    };
    try {
      const res = await API.getRoleList(params);
      context.commit("setRoleList", res.data);
      return res.data;
    } catch (error) {
      console.log(error);
      const code = error?.response?.data?.code;
      context.commit("user/set_roles_access_code", +code, {
        root: true,
      });
      throw error;
    }
  },
  async addRoleToUser(context, data) {
    const currentId = this.state.user.currentId.profile_id;
    const params = {
      profile_id: currentId,
      ...data,
    };
    try {
      const unused_res = await API.addRoleToUser(params);
    } catch (err) {
      console.log(err);
      throw err;
    }
  },
  async addRoleToTeam(context, data) {
    const currentId = this.state.user.currentId.profile_id;
    const params = {
      profile_id: currentId,
      ...data,
    };
    try {
      const unused_res = await API.addRoleToTeam(params);
    } catch (err) {
      console.log(err);
      throw err;
    }
  },

  async deleteUserRole(context, data) {
    const currentId = this.state.user.currentId.profile_id;
    const params = {
      profile_id: currentId,
      ...data,
    };
    try {
      const unused_res = await API.deleteUserRole(params);
    } catch (err) {
      console.log(err);
      throw err;
    }
  },
  async getUserListInRole(context, data) {
    const currentId = this.state.user.currentId.profile_id;
    const params = {
      profile_id: currentId,
      page: 1,
      per_page: 25,
      ...data,
    };
    try {
      const res = await API.getUserListInRole(params);
      context.commit("setUserListInRole", res.data);
      return res.data;
    } catch (err) {
      console.log(err);
      throw err;
    }
  },

  /*------------------------- team ---------------------------*/

  // get full team list
  async getTeamList(context, data) {
    if (getIsAccessDisabled(context.rootState?.user?.teams_access_code)) {
      return;
    }
    const currentId = this.state.user.currentId.profile_id;
    const max_user = this.state.user.systemConfig.default_iam_max_user_snippets;
    const params = {
      profile_id: currentId,
      max_user_snippets: max_user,
      is_full_page_search: true,
      ...data,
    };
    try {
      const res = await API.getTeamList(params);
      context.commit("setTeamList", res.data);
    } catch (error) {
      console.log(error);
      const code = error?.response?.data?.code;
      context.commit("user/set_teams_access_code", +code, {
        root: true,
      });
      throw error;
    }
  },
  async createTeam(context, data) {
    const currentId = this.state.user.currentId.profile_id;
    const params = {
      profile_id: currentId,
      ...data,
    };
    try {
      const res = await API.createTeam(params);
      return res.data;
    } catch (err) {
      console.log(err);
      throw err;
    }
  },
  async updateTeam(context, data) {
    const currentId = this.state.user.currentId.profile_id;
    const params = {
      profile_id: currentId,
      ...data,
    };
    try {
      const unused_res = await API.updateTeam(params);
    } catch (err) {
      console.log(err);
      throw err;
    }
  },
  async deleteTeam(context, data) {
    const currentId = this.state.user.currentId.profile_id;
    const params = {
      profile_id: currentId,
      ...data,
    };
    try {
      const unused_res = await API.deleteTeam(params);
    } catch (err) {
      console.log(err);
      throw err;
    }
  },
  async deleteUserTeam(context, data) {
    const currentId = this.state.user.currentId.profile_id;
    const params = {
      profile_id: currentId,
      ...data,
    };
    try {
      const res = await API.deleteUserTeam(params);
      return res.data;
    } catch (err) {
      console.log(err);
      throw err;
    }
  },
  async getUserListInTeam(context, data) {
    const currentId = this.state.user.currentId.profile_id;
    const params = {
      profile_id: currentId,
      page: 1,
      per_page: 25,
      ...data,
    };
    try {
      const res = await API.getUserListInTeam(params);
      context.commit("setUserListInTeam", res.data);
      return res.data;
    } catch (err) {
      console.log(err);
      throw err;
    }
  },
  async updateTeamUser(context, data) {
    const currentId = this.state.user.currentId.profile_id;
    const params = {
      profile_id: currentId,
      ...data,
    };
    try {
      const res = await API.updateTeamUser(params);
      return res.data;
    } catch (err) {
      console.log(err);
      throw err;
    }
  },
  async updateTeamRole(context, data) {
    const currentId = this.state.user.currentId.profile_id;
    const params = {
      profile_id: currentId,
      ...data,
    };
    try {
      const res = await API.updateTeamRole(params);
      return res.data;
    } catch (err) {
      console.log(err);
      throw err;
    }
  },
  async addTeamToUser(context, data) {
    const currentId = this.state.user.currentId.profile_id;
    const params = {
      profile_id: currentId,
      ...data,
    };
    try {
      const res = await API.addTeamToUser(params);
      return res.data;
    } catch (err) {
      console.log(err);
      throw err;
    }
  },
  /*------------------------- relation ---------------------------*/

  async getTeamRelationList(context, data) {
    if (
      getIsAccessDisabled(context.rootState?.user?.teams_relation_access_code)
    ) {
      return;
    }
    const currentId = this.state.user.currentId.profile_id;
    const params = {
      profile_id: currentId,
      ...data,
    };
    try {
      const res = await API.getTeamRelationList(params);
      context.commit("setTeamRelationList", res.data);
      return res.data;
    } catch (error) {
      console.log(error);
      const code = error?.response?.data?.code;
      context.commit("user/set_teams_relation_access_code", +code, {
        root: true,
      });
      throw error;
    }
  },
  async modifyTeamRelation(context, data) {
    const currentId = this.state.user.currentId.profile_id;
    const params = {
      profile_id: currentId,
      ...data,
    };
    try {
      const res = await API.modifyTeamRelation(params);
      return res.data;
    } catch (err) {
      console.log(err);
      throw err;
    }
  },
  async deleteTeamRelation(context, data) {
    const currentId = this.state.user.currentId.profile_id;
    const params = {
      profile_id: currentId,
      ...data,
    };
    try {
      const res = await API.deleteTeamRelation(params);
      return res.data;
    } catch (err) {
      console.log(err);
      throw err;
    }
  },
  async addTeamRelation(context, data) {
    const currentId = this.state.user.currentId.profile_id;
    const params = {
      profile_id: currentId,
      ...data,
    };
    try {
      const res = await API.addTeamRelation(params);
      return res.data;
    } catch (err) {
      console.log(err);
      throw err;
    }
  },
  async getTeamRelationType(context) {
    const currentId = this.state.user.currentId.profile_id;
    const params = {
      profile_id: currentId,
    };
    try {
      const res = await API.getTeamRelationType(params);
      context.commit("setTeamRelationType", res.data);
      return res.data;
    } catch (err) {
      console.log(err);
      throw err; // 重新抛出错误
    }
  },
  /*------------------------- sharing rules ---------------------------*/
  async createSharingRulesGroup(context, data) {
    const currentId = this.state.user.currentId.profile_id;
    try {
      const res = await API.createSharingRulesGroup({
        profile_id: currentId,
        ...data,
      });
      return res.data;
    } catch (err) {
      console.log(err);
      throw err; // 重新抛出错误
    }
  },
  async deleteSharingRulesGroup(context, data) {
    const currentId = this.state.user.currentId.profile_id;
    try {
      const res = await API.deleteSharingRulesGroup({
        profile_id: currentId,
        ...data,
      });
      return res.data;
    } catch (err) {
      console.log(err);
      throw err;
    }
  },
  async updateSharingRulesGroup(context, data) {
    const currentId = this.state.user.currentId.profile_id;
    try {
      const res = await API.updateSharingRulesGroup({
        profile_id: currentId,
        ...data,
      });
      return res.data;
    } catch (err) {
      console.log(err);
      throw err;
    }
  },
  async getSharingRulesGroupList(context, data) {
    const currentId = this.state.user.currentId.profile_id;
    try {
      const res = await API.getSharingRulesGroupList({
        profile_id: currentId,
        ...data,
      });
      context.commit("setSharingRulesGroup", res.data);
      return res.data;
    } catch (err) {
      console.log(err);
      throw err;
    }
  },
  async updateSharingRules(context, data) {
    const currentId = this.state.user.currentId.profile_id;
    try {
      const res = await API.updateSharingRules({
        profile_id: currentId,
        ...data,
      });
      return res.data;
    } catch (err) {
      console.log(err);
      throw err;
    }
  },
};
export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
